export enum TypeformStatus {
  AVAILABLE = 'AVAILABLE',
  MISSING_ID = 'MISSING_ID',
  UNKNOWN_FORM = 'UNKNOWN_FORM',
}
